<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-3 d-print-none d-flex align-items-center">
          <span class="toolbar-title">Shielding Control Forms</span>
        </div>
        <div
          class="col-sm-12 col-md-3 d-flex align-items-start flex-column justify-content-center"
        >
          <h1
            [ngClass]="scfMaster?.formStatus?.color"
            id="serialNumber"
            [matTooltip]="scfMaster?.wfTable?.name ?? ''"
          >
            {{ scfMaster?.serialNo }}
          </h1>
          <span
            *ngIf="scfMaster"
            class="status"
            [ngClass]="scfMaster.formStatus?.color"
          >
            {{ scfMaster.formStatus?.name }}
          </span>
        </div>
        <!-- Bug 6961: share one row with Created Date on narrow screens to keep the wrapped header short -->
        <div class="col-6 col-md-2 type-header d-flex align-items-center">
          <mat-form-field
            appearance="outline"
            *ngIf="scfMaster"
            class="no-subscript"
          >
            <mat-label>Initiated by</mat-label>
            <input
              aria-label="operator"
              matInput
              type="text"
              name="operator_form"
              [(ngModel)]="scfMaster.createdByName"
              disabled
            />
          </mat-form-field>
        </div>
        <div class="col-6 col-md-2 type-header d-flex align-items-center">
          <mat-form-field
            appearance="outline"
            *ngIf="scfMaster"
            class="no-subscript"
          >
            <mat-label>Created Date</mat-label>
            <input
              matInput
              class="dateInput"
              name="dateNow"
              placeholder="Date"
              disabled
              datetime="MM-dd-yyyy"
              [value]="formatDate(scfMaster.createdOn)"
            />
          </mat-form-field>
        </div>
        <div
          class="col-12 col-md-2 d-flex flex-column justify-content-center align-items-end"
        >
          <div class="d-flex small" *ngIf="showAmendmentToggle">
            <mat-slide-toggle
              [(ngModel)]="status.isViewingAmendment"
              class="float-right d-print-none"
              name="amendment"
              (change)="changeAmendmentToggle($event)"
              >Show Pending Amendment</mat-slide-toggle
            >
          </div>
          <div class="d-flex small d-print-none" *ngIf="scfMaster?.editingBy">
            Modifying by:&nbsp;<b class="yellow">{{
              scfMaster?.editingBy?.name
            }}</b>
          </div>
          <div class="col reason full-width d-flex flex-column justify-content-center"
              *ngIf="
                scfMaster &&
                scfMaster.status === formStatusEnum.Canceled &&
                scfMaster.cancelReason
              "
            >
              <div class="small">Reason for cancellation:</div>
              <div>
                <b class="red small">
                  {{ scfMaster.cancelReason }}
                </b>
              </div>
            </div>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item class="show-overflow">
          <!-- <span *ngIf="isExpanded || isShowing">Filter</span> -->
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
          <mat-hint align="start"
            >Use <span style="color: red">-term</span> to exclude
            results</mat-hint
          >
        </mat-list-item>

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <scf-v2-side
              [filter]="filter"
              (rowSelected)="rowSelected($event)"
            ></scf-v2-side>
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          (click)="openHoldPointDashboard()"
          class="parent"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >SCF Hold Points</span
          >
          <mat-icon matListItemIcon class="blue">dashboard</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="create()"
          class="parent"
          *ngIf="privileges.canCreate"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="edit()"
          class="parent"
          *ngIf="
            privileges.canEdit &&
            !status.isEditing &&
            !status.isEditingAmendment
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Modify Form</span
          >
          <mat-icon matListItemIcon class="yellow">edit</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="editAmendment()"
          class="parent"
          *ngIf="
            scfMaster &&
            privileges.canEditAmendment &&
            !status.isEditing &&
            !status.isEditingAmendment &&
            !status.isCreatingAmendment &&
            !scfMaster.editingBy
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Modify Amendment</span
          >
          <mat-icon matListItemIcon class="yellow">edit</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="duplicate()"
          class="parent"
          *ngIf="
            scfMaster &&
            privileges.canDuplicate &&
            !status.isCreating &&
            !status.isEditing &&
            scfMaster.status !== formStatusEnum.New
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Copy Form</span
          >
          <mat-icon matListItemIcon class="blue">content_copy</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="requestAmendment()"
          class="parent"
          [disabled]="status.isCreatingAmendment"
          *ngIf="
            scfMaster &&
            (scfMaster.status === formStatusEnum.Active ||
              scfMaster.status === formStatusEnum.HoldPoint) &&
            privileges.canCreateAmendment
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create Amendment</span
          >
          <mat-icon matListItemIcon class="red">healing</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="release()"
          class="parent"
          *ngIf="privileges.canRelease"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Release Form</span
          >
          <mat-icon matListItemIcon class="red">lock_open</mat-icon>
        </mat-list-item>
        <a
          mat-list-item
          href="{{ procedureAppendix?.file?.url }}"
          target="_blank"
          *ngIf="procedureAppendix?.file"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Offline Form</span
          >
          <mat-icon matListItemIcon class="red">picture_as_pdf</mat-icon>
        </a>
        <a
          mat-list-item
          href="https://forms.gle/TC1rCpqRNnpJWib18"
          target="_blank"
          *ngIf="isRequester()"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Request SCF</span
          >
          <mat-icon matListItemIcon class="blue">edit_note</mat-icon>
        </a>
        <form-history-button
          #showHistory
          [isExpanded]="isExpanded"
          [isShowing]="isShowing"
          [hidden]="!scfMaster"
        ></form-history-button>

        <mat-list-item
          *ngIf="isSA()"
          (click)="settings()"
          class="parent line-top"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Settings</span
          >
          <mat-icon matListItemIcon class="gray">settings</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div
          class="sidenav-content"
          [ngClass]="{
            amendment: status.isViewingAmendment,
          }"
        >
          <div *ngIf="!showHistory?.value">
            <scf-v2-main
              #main
              [scfMaster]="scfMaster"
              [disabled]="disabled"
              [privileges]="privileges"
              [status]="status"
              (setStatus)="setStatus($event)"
              (saved)="savedEvent($event)"
            ></scf-v2-main>

            <div
              class="buttons d-print-none"
              id="sidenav-content-buttons"
              [ngClass]="{
                'buttons-amendment':
                  scfMaster &&
                  (this.status.isCreatingAmendment ||
                    this.status.isEditingAmendment) &&
                  this.status.isViewingAmendment,
              }"
            >
              <scf-v2-main-buttons
                *ngIf="buttonsVisible"
                [scfMaster]="scfMaster"
                [disabled]="disabled"
                [privileges]="privileges"
                [status]="this.status"
                [valid]="mainValid()"
                (setSetatus)="setStatus($event)"
                (saved)="savedEvent($event)"
                (saveClicked)="saveEvent()"
              >
              </scf-v2-main-buttons>
            </div>
          </div>
          <form-history
            [form]="scfMaster"
            class="mt-2"
            *ngIf="showHistory.value"
          ></form-history>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
